import React from 'react';
import styles from './PatienCasesPage.module.css';

// Hooks
import useCaseHistoricQuery from './useCaseHistoricQuery';

// Components
import CasesTable from '../../components/CasesPage/CasesTable/CasesTable';
import ToolbarCases from '../../components/CasesPage/ToolbarCases/ToolbarCases';
import ErrorSpinnerWrapper from '../../components/UI/ErrorSpinnerWrapper.tsx/ErrorSpinnerWrapper';

// Models
import CasesPaginator from '../../components/CasesPage/CasesPaginator/CasesPaginator';
import useFilterCaseHistory from './useFilterCaseHistory';


const PatientCasesPage: React.FC = () => {

    const {
        columns,
        filters,
        currentPage,
        columnOrder,
        dispatchFilters,
        setColumnOrder,
        setCurrentPage,
        changeVisibility,
    } = useFilterCaseHistory();

    const {
        numPages,
        totalCases,
        totalCasesUnfiltered,
        isLoading,
        error,
        historicCases,
    } = useCaseHistoricQuery(filters, currentPage, columnOrder.col, columnOrder.asc);


    return (
        <div className='pageContainer'>
            <ToolbarCases
                totalFiltered={totalCases ?? 0}
                totalCases={totalCasesUnfiltered ?? 0}
                columns={columns}
                filtersCases={filters}
                dispatchFilters={dispatchFilters}
                changeVisibility={changeVisibility}
            />
            <ErrorSpinnerWrapper loading={isLoading} error={error}>
                <div className={styles.casesContent}>
                    <CasesTable
                        columns={columns}
                        historicCases={historicCases}
                        columnOrder={columnOrder}
                        setColumnOrder={setColumnOrder}
                    />
                    {numPages > 0 &&
                        <CasesPaginator
                            currentPage={currentPage}
                            setCurrentPage={setCurrentPage}
                            numPages={numPages}
                        />
                    }
                </div>
            </ErrorSpinnerWrapper>
        </div>
    );
};

export default PatientCasesPage;